import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  Signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Carousel } from 'primeng/carousel';
import {
  ResponsiveCarouselOptions,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { Observable } from 'rxjs';
import {
  PublicBrand,
  PublicBrandDataSourceService,
} from '@web/shared/module/brand';
import {
  Route,
  RouteParam,
  RouterLinkComponent,
  RouterLinkParams,
} from '@web/common';
import { PublicHighlightedBrandTileComponent } from '../../components/public-highlighted-brand-tile/public-highlighted-brand-tile.component';

@Component({
  selector: 'app-public-highlighted-brands-carousel',
  imports: [
    CommonModule,
    Carousel,
    SpinnerFilledComponent,
    RouterLinkComponent,
    PublicHighlightedBrandTileComponent,
  ],
  templateUrl: './public-highlighted-brands-carousel.component.html',
  styleUrl: './public-highlighted-brands-carousel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicHighlightedBrandsCarouselComponent {
  protected readonly responsiveOptions = this.responsiveOptionsSignal();
  protected readonly brands$: Observable<PublicBrand[]>;
  protected readonly Route = Route;

  private readonly publicBrandDataSource = inject(PublicBrandDataSourceService);

  public constructor() {
    this.brands$ = this.brandsSource();
  }

  public routerLinkParams(slug: string): RouterLinkParams {
    return {
      [RouteParam.Slug]: slug,
    };
  }

  private responsiveOptionsSignal(): Signal<ResponsiveCarouselOptions[]> {
    return signal([
      {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 1,
      },
      {
        breakpoint: '640px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '480px',
        numVisible: 1,
        numScroll: 1,
      },
    ]);
  }

  private brandsSource(): Observable<PublicBrand[]> {
    return this.publicBrandDataSource.fetchHighlightedBrands();
  }
}
